/**
 * DialHoop Medical Field Options
 * Single source of truth for all dropdown values.
 * Used in OrderPage (user form) and AdminPage (edit modal).
 */

export const BLOOD_GROUP_OPTIONS = [
  { value: "",        label: "Select blood group…" },
  { value: "A+",      label: "A+" },
  { value: "A-",      label: "A−" },
  { value: "B+",      label: "B+" },
  { value: "B-",      label: "B−" },
  { value: "AB+",     label: "AB+" },
  { value: "AB-",     label: "AB−" },
  { value: "O+",      label: "O+" },
  { value: "O-",      label: "O−" },
  { value: "Unknown", label: "Unknown / Not sure" },
];

export const DIABETES_OPTIONS = [
  { value: "",              label: "Select diabetes status…" },
  { value: "No",          label: "No" },
  { value: "Yes",        label: "Yes" },
  { value: "Unknown",       label: "Unknown / Not sure" },
];

export const BLOOD_PRESSURE_OPTIONS = [
  { value: "",              label: "Select blood pressure status…" },
  { value: "No",        label: "No" },
  { value: "Yes",      label: "Yes" },
  { value: "Unknown",       label: "Unknown / Not sure" },
];

export const GENDER_OPTIONS = [
  { value: "",               label: "Select gender…" },
  { value: "Male",           label: "Male" },
  { value: "Female",         label: "Female" },
  { value: "Non-binary",     label: "Non-binary" },
  { value: "Prefer not to say", label: "Prefer not to say" },
];
